module.exports = __webpack_public_path__ + "img/karriere-weiterbildung-v5.e5b622c4.jpg";